import { render, staticRenderFns } from "./editReason.vue?vue&type=template&id=3bfe1ca3&scoped=true&"
import script from "./editReason.vue?vue&type=script&lang=js&"
export * from "./editReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfe1ca3",
  null
  
)

export default component.exports